"use strict";
/* THIS IS A GENERATED FILE */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkubanaAnalyticsApiClient = void 0;
const BaseApiClient_1 = require("./BaseApiClient");
class SkubanaAnalyticsApiClient extends BaseApiClient_1.BaseApiClient {
    async retrieveCogs(queryParams) {
        const path = `/v1/analytics/accounting/cogsbysaleschannels`;
        return await this.request("get", path, queryParams, undefined);
    }
    async retrieveASalesSummary(queryParams) {
        const path = `/v1/analytics/accounting/salessummary`;
        return await this.request("get", path, queryParams, undefined);
    }
    async retrieveProductCurrentCostsByWarehouse(warehouseId, queryParams) {
        const path = `/v1/analytics/cogs/${warehouseId || ""}/current`;
        return await this.request("get", path, queryParams, undefined);
    }
}
exports.SkubanaAnalyticsApiClient = SkubanaAnalyticsApiClient;
